module.exports = __webpack_public_path__ + "img/logo.3837f186.png";